import React from "react";
import Tooltip, { ComponentWithTooltipProps } from "../../tooltip/Tooltip";

import { Play, Pause } from "../../svg/svgImageList";
import Button from "../../button/Button";
import { videoPlayerService } from "../../../services/video-player/VideoPlayerService";

const elementId = "video-play";

export default function PlayPause({ tooltipTextKey }: ComponentWithTooltipProps) {
  const { isVideoPlaying, stopVideo, startVideo } = videoPlayerService;

  return (
    <Tooltip id={elementId} title={tooltipTextKey}>
      <Button
        id={elementId}
        onClick={isVideoPlaying ? stopVideo : startVideo}
        icon={{
          svg: isVideoPlaying ? Pause : Play,
          className: "video-control-item",
        }}
      />
    </Tooltip>
  );
}
